/**
 * Constants for different types of context.
 * @type {{
 *   guest: string,
 *   planBuilderUser: string,
 *   externalUser: string
 * }}
 */
const CONTEXT_TYPES = {
    guest: 'guest',
    planBuilderUser: 'account',
    externalUser: 'external',
}

export default CONTEXT_TYPES
